import React from 'react';
import { withRouter } from 'react-router';
import styles from './styles';
import { useHistory } from "react-router-dom";
import BackgroundImage from 'media/backgroundSidePanel.png';
const SideMenu = ({ open, toggle }) => {
    const history = useHistory();
    return (
        <>  
            <styles.BackPanel open={open} onClick={toggle}/>
            <styles.ContainerPanel open={open} img={BackgroundImage}>
                <styles.ContainerMenu >
                    <styles.MenuOption onClick={() => {toggle(); history.push('landing?section=home');}}>HOME</styles.MenuOption>
                    <styles.MenuOption onClick={() => {toggle(); history.push('landing?section=about');}}>ABOUT US</styles.MenuOption>
                    <styles.MenuOption onClick={() => {toggle(); history.push('landing?section=portfolio');}}>PORTFOLIO</styles.MenuOption>
                    <styles.MenuOption onClick={() => {toggle(); history.push('/project-scoping');}}>PROJECT SCOPING</styles.MenuOption>
                    <styles.MenuOption onClick={() => {toggle(); history.push('shop');}}><b>SERVICES</b></styles.MenuOption>
                    <styles.MenuOption  onClick={()=>{window.open("https://calendly.com/luisenriquecgongora")}}><b>FREE CONSULTATION</b></styles.MenuOption>
                </styles.ContainerMenu>
            </styles.ContainerPanel>
        </>

    );
};

export default withRouter(SideMenu);
